import { useContext } from 'react';
import { UserProfileContext } from './context';

export function useUserProfileContext() {
  const userProfileContext = useContext(UserProfileContext);
  return userProfileContext;
}
